import React, { useMemo } from 'react';
import { StyledTable } from 'modules/components/layer24';
import { SuperAdminTableRow } from 'modules/components/layer23';

import * as ds from './dataService';


export type SuperAdminTableProps = {};

export const FC = (props: SuperAdminTableProps) => {


  const { data } = ds.useQuery();

  const headers: string[] = [];

  const rows = useMemo(() => {
    return data.map((node, i) => (
      <SuperAdminTableRow.FC
        key={i}
        {...node}
      />
    ));
  }, [data]);

  return (
    <StyledTable.FC
      headers={headers}
      rows={rows}
    />

  );
};
